import {
  JobPipeline,
  JobPipelineJobsDropdown,
  TopbarContainer,
  TopbarTitle,
} from "@/components";

export const JobPipelinePage = () => {
  return (
    <div className="flex h-svh flex-col">
      <TopbarContainer className="flex items-center justify-between">
        <TopbarTitle>Pipeline</TopbarTitle>
        <JobPipelineJobsDropdown />
      </TopbarContainer>
      <JobPipeline className="min-h-0 p-6" />
    </div>
  );
};
